import { useEffect, useRef } from 'react';

/**
 * Track mode completions for timeline unlocks
 * Increments counters when users complete contest/pileup/head copy sessions
 */
export const useModeTracking = (gameView, gameMode, sessionStart, setUserSettings) => {
    const previousGameMode = useRef(null);
    const previousView = useRef(null);

    useEffect(() => {
        // Detect when leaving game view (session ended)
        if (previousView.current === 'game' && gameView !== 'game') {
            const mode = previousGameMode.current;
            const sessionDuration = (Date.now() - sessionStart) / 1000;

            // Only count if session was at least 30 seconds (meaningful play)
            if (sessionDuration >= 30) {
                if (mode === 'contests') {
                    setUserSettings(prev => {
                        const updated = { ...prev, contestCompleted: (prev.contestCompleted || 0) + 1 };
                        localStorage.setItem('morse_settings_v1', JSON.stringify(updated));
                        return updated;
                    });
                } else if (mode === 'pileup') {
                    setUserSettings(prev => {
                        const updated = { ...prev, pileupCompleted: (prev.pileupCompleted || 0) + 1 };
                        localStorage.setItem('morse_settings_v1', JSON.stringify(updated));
                        return updated;
                    });
                }
            }
        }

        previousGameMode.current = gameMode;
        previousView.current = gameView;
    }, [gameView, gameMode, sessionStart, setUserSettings]);
};
